"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFiles = require("react-files");

var _reactFiles2 = _interopRequireDefault(_reactFiles);

var _formData = require("form-data");

var _formData2 = _interopRequireDefault(_formData);

var _blob = require("blob");

var _blob2 = _interopRequireDefault(_blob);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _PanelSelectDB = require("./PanelSelectDB.css");

var _PanelSelectDB2 = _interopRequireDefault(_PanelSelectDB);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var PanelSelectDB = function (_Component) {
	_inherits(PanelSelectDB, _Component);

	function PanelSelectDB(props) {
		_classCallCheck(this, PanelSelectDB);

		var _this = _possibleConstructorReturn(this, (PanelSelectDB.__proto__ || Object.getPrototypeOf(PanelSelectDB)).call(this, props));

		_this.handleCSVChange = function (e, _ref) {
			var value = _ref.value;


			_this.updateDBState("", true);
		};

		_this.handleDBChange = function (e, _ref2) {
			var value = _ref2.value;


			_this.updateDBState(value);
		};

		_this.onFilesChange = function (files) {
			var _this2 = this;

			this.setState({ uploading: true });

			var formData = new _formData2.default();
			formData.append("csvdata", new _blob2.default([files[0]], { type: files[0].type }), files[0].name || "file.csv");

			_request2.default.post(CONSTANTS.URL_UPLOAD_CSV, formData).then(function (data) {

				_this2.setState({
					uploading: false,
					hasFileBeenUploaded: true,
					missingCSVFile: false,
					showCSVFileError: false
				});
				_this2.updateDBState(data.output, true);
			}).catch(function (err) {

				_this2.setState({ showCSVFileError: true, uploading: false });
			});
		};

		_this.onFilesError = function (error, file) {
			console.log("error code " + error.code + ": " + error.message);
		};

		_this.state = {
			/* databasename: CONSTANTS.DB_TEMPS_ACTUAL,
   isCSVFile: false, */
			uploading: false,
			hasFileBeenUploaded: false,
			missingCSVFile: props.data.isCSVFile && props.data.databasename === ""
		};

		return _this;
	}

	_createClass(PanelSelectDB, [{
		key: "updateDBState",
		value: function updateDBState(dbname) {
			var isCSV = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			//this.setState({ databasename: dbname, isCSVFile: isCSV });

			this.props.updateJsonConfig(["data", "selectedfields", "calcdatafieldsOptions", "calcdatafieldsCalculs", "calcdatafields", "vieweroptions"], [{ isCSVFile: isCSV, databasename: dbname }, CONSTANTS.defaultJsonConfig.selectedfields, CONSTANTS.defaultJsonConfig.calcdatafieldsOptions, CONSTANTS.defaultJsonConfig.calcdatafieldsCalculs, CONSTANTS.defaultJsonConfig.calcdatafields, CONSTANTS.defaultJsonConfig.vieweroptions]);
		}
	}, {
		key: "renderLoading",
		value: function renderLoading() {

			if (this.state.uploading) {
				return _react2.default.createElement(
					_semanticUiReact.Dimmer,
					{ active: true },
					_react2.default.createElement(
						_semanticUiReact.Loader,
						{ indeterminate: true },
						"Pujant fitxer"
					)
				);
			}
		}
	}, {
		key: "renderSegmentDatabase",
		value: function renderSegmentDatabase() {

			return _react2.default.createElement(
				_semanticUiReact.Segment.Group,
				null,
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ className: _PanelSelectDB2.default.segmentHeader, as: "h5", attached: "top", block: true },
					"Bases de Dades predefinides"
				),
				_react2.default.createElement(
					_semanticUiReact.Segment,
					null,
					_react2.default.createElement(_semanticUiReact.Radio, {
						label: "Temps Actual",
						name: "db_radioGroup",
						value: CONSTANTS.DB_TEMPS_ACTUAL,
						checked: this.props.data.databasename === CONSTANTS.DB_TEMPS_ACTUAL,
						onChange: this.handleDBChange,
						className: _PanelSelectDB2.default.mySelected
					})
				),
				_react2.default.createElement(
					_semanticUiReact.Segment,
					null,
					_react2.default.createElement(_semanticUiReact.Radio, {
						label: "MeteoDades",
						name: "db_radioGroup",
						value: CONSTANTS.DB_METEODADES,
						checked: this.props.data.databasename === CONSTANTS.DB_METEODADES,
						onChange: this.handleDBChange
					})
				)
			);
		}

		//TODO check https://pqina.nl/filepond/ for file upload!!!!

	}, {
		key: "renderCSVFilename",
		value: function renderCSVFilename() {
			var _this3 = this;

			if (this.props.data.isCSVFile && this.props.data.databasename !== "") {

				return _react2.default.createElement(
					"div",
					{ className: _PanelSelectDB2.default.divFilename },
					_react2.default.createElement(
						_semanticUiReact.Label,
						null,
						_react2.default.createElement(_semanticUiReact.Icon, { name: "file" }),
						this.props.data.databasename
					),
					_react2.default.createElement(_semanticUiReact.Label, { className: _PanelSelectDB2.default.pointer, pointing: "left", color: "red", icon: "trash", onClick: function onClick() {
							return _this3.props.updateJsonConfig("data", { isCSVFile: true, databasename: "" });
						} })
				);
			}
		}
	}, {
		key: "renderCSVFileCheck",
		value: function renderCSVFileCheck() {
			var _this4 = this;

			if (this.state.showCSVFileError) {

				return _react2.default.createElement(_semanticUiReact.Message, {
					onDismiss: function onDismiss() {
						return _this4.setState({ showCSVFileError: false });
					},
					header: "Error",
					content: "Problema en pujar al servidor el fitxer seleccionat. Torni a intentar-ho."
				});
			} else if (this.props.data.databasename === "") {
				return _react2.default.createElement(
					_semanticUiReact.Label,
					{ basic: true, color: "red", pointing: true },
					"Si us plau, selecciona un fitxer"
				);
			}
		}
	}, {
		key: "renderButtonUploadFile",
		value: function renderButtonUploadFile() {

			if (this.props.data.databasename === "") {
				return _react2.default.createElement(
					_reactFiles2.default,
					{
						className: _PanelSelectDB2.default.filesDropzone,
						onChange: this.onFilesChange.bind(this),
						onError: this.onFilesError.bind(this),
						accepts: [".csv"],
						multiple: false,
						maxFiles: 1,
						maxFileSize: 10000000,
						minFileSize: 0,
						clickable: !this.state.uploading
					},
					"Arrossega un fitxer o fes clic per carregar"
				);
			}
		}
	}, {
		key: "renderSegmentCsv",
		value: function renderSegmentCsv() {
			var _this5 = this;

			return _react2.default.createElement(
				_semanticUiReact.Segment.Group,
				null,
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ className: _PanelSelectDB2.default.segmentHeader, as: "h5", attached: true, block: true },
					"Carrega manual de fitxer CSV"
				),
				_react2.default.createElement(
					_semanticUiReact.Segment,
					null,
					_react2.default.createElement(_semanticUiReact.Radio, {
						label: "Fitxer CSV",
						name: "db_radioGroup",
						value: CONSTANTS.DB_FITXER_CSV,
						checked: this.props.data.isCSVFile,
						onChange: this.handleCSVChange
					}),
					this.renderCSVFilename(),
					this.state.hasFileBeenUploaded && _react2.default.createElement(
						_semanticUiReact.Message,
						{ onDismiss: function onDismiss() {
								return _this5.setState({ hasFileBeenUploaded: false });
							}, positive: true },
						_react2.default.createElement(
							"p",
							null,
							_react2.default.createElement(_semanticUiReact.Icon, { name: "check" }),
							" Pujada correcta"
						)
					),
					this.renderButtonUploadFile(),
					this.renderCSVFileCheck(),
					this.renderLoading()
				)
			);
		}
	}, {
		key: "render",
		value: function render() {

			return _react2.default.createElement(
				"div",
				{ className: _PanelSelectDB2.default.containerSegment },
				this.renderSegmentDatabase(),
				this.renderSegmentCsv()
			);
		}
	}, {
		key: "isValid",
		value: function isValid() {

			var missingCSVFile = this.state.isCSVFile && !this.state.hasFileBeenUploaded;
			this.setState({ missingCSVFile: missingCSVFile });

			return !missingCSVFile;
		}
	}, {
		key: "getJsonconfigState",
		value: function getJsonconfigState() {
			return null;
		}
	}], [{
		key: "getDerivedStateFromProps",
		value: function getDerivedStateFromProps(nextProps, prevState) {

			return null;
		}
	}]);

	return PanelSelectDB;
}(_react.Component);

exports.default = PanelSelectDB;


PanelSelectDB.propTypes = {
	data: _propTypes2.default.object,
	updateJsonConfig: _propTypes2.default.func
};
